import { Loader2 } from "lucide-react";

export const PageLoader = ({ label = "Loading..." }) => (
  <div
    className="flex min-h-[60vh] flex-col items-center justify-center gap-3"
    data-testid="page-loader"
  >
    <Loader2 className="h-7 w-7 animate-spin" style={{ color: "var(--gm-red)" }} />
    <p className="text-sm" style={{ color: "var(--gm-muted)" }}>
      {label}
    </p>
  </div>
);

export const PageError = ({ onRetry, message }) => (
  <div
    className="gm-container flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center"
    data-testid="page-error"
  >
    <h2 className="text-xl font-bold text-white">Alamak, cannot load the content</h2>
    <p className="max-w-md text-sm" style={{ color: "var(--gm-muted)" }}>
      {message || "The server did not respond. Check your connection and try again."}
    </p>
    {onRetry ? (
      <button
        type="button"
        onClick={onRetry}
        data-testid="page-error-retry"
        className="gm-btn-red min-h-[46px] rounded-xl px-5 text-sm font-bold"
      >
        Try again
      </button>
    ) : null}
  </div>
);
